import { Languages, LogOut, Moon, Sun, SunMoon, User } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { queryClient } from "@/libs/react-query";
import { cn } from "@/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

import { useTheme } from "./theme-provider";
import { UserProfileButton } from "./user-profile-button";

export function UserProfileMenu() {
  const { theme, setTheme } = useTheme();
  const { t, i18n } = useTranslation();

  const { logout } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });

    //empty reach-query cache
    queryClient.clear();
  };
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <UserProfileButton />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 rounded-2xl border border-border bg-card">
        <DropdownMenuGroup className="rounded-xl border border-border bg-background p-1 px-1">
          <DropdownMenuItem className="text-sm" disabled>
            <User />
            <span>{t("userMenu.profile")}</span>
          </DropdownMenuItem>

          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Sun />
              <span>{t("userMenu.theme")}</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                <DropdownMenuItem
                  onClick={() => setTheme("light")}
                  className={cn(
                    theme === "light" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <Sun />
                  <span>{t("userMenu.light")}</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => setTheme("dark")}
                  className={cn(
                    theme === "dark" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <Moon />
                  <span>{t("userMenu.dark")}</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => setTheme("system")}
                  className={cn(
                    theme === "system" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <SunMoon />
                  <span>{t("userMenu.system")}</span>
                </DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>

          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <Languages />
              <span>{t("userMenu.language")}</span>
            </DropdownMenuSubTrigger>
            <DropdownMenuPortal>
              <DropdownMenuSubContent>
                <DropdownMenuItem
                  onClick={() => i18n.changeLanguage("en")}
                  className={cn(
                    i18n.resolvedLanguage === "en" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <span>{t("userMenu.english")}</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => i18n.changeLanguage("hu")}
                  className={cn(
                    i18n.resolvedLanguage === "hu" && "bg-background",
                    "cursor-pointer",
                  )}
                >
                  <span>{t("userMenu.hungarian")}</span>
                </DropdownMenuItem>
              </DropdownMenuSubContent>
            </DropdownMenuPortal>
          </DropdownMenuSub>
        </DropdownMenuGroup>

        <DropdownMenuItem
          onClick={handleLogout}
          className="mb-2 mt-4 cursor-pointer"
        >
          <LogOut />
          <span>{t("userMenu.logOut")}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
